module.exports = __webpack_public_path__ + "img/peh33_power_on_camera.c24c1416.png";